/* eslint-disable import/no-unresolved, no-restricted-syntax */
import Tooltip from 'bootstrap/js/dist/tooltip';

(() => {
  // Initialize tooltips on page load
  const initializeTooltips = (container = document) => {
    const tooltipTriggerList = container.querySelectorAll(
      '[data-bs-toggle="tooltip"]',
    );
    [...tooltipTriggerList].forEach((tooltipTriggerEl) => {
      // Check if tooltip is already initialized
      if (!Tooltip.getInstance(tooltipTriggerEl)) {
        new Tooltip(tooltipTriggerEl);
      }
    });
  };

  // Initialize existing tooltips
  initializeTooltips();

  // Watch for dynamically added tooltips
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      mutation.addedNodes.forEach((node) => {
        if (node.nodeType === 1) { // Element node
          // Check if the added node itself has data-bs-toggle="tooltip"
          if (node.hasAttribute && node.hasAttribute('data-bs-toggle') && node.getAttribute('data-bs-toggle') === 'tooltip') {
            if (!Tooltip.getInstance(node)) {
              new Tooltip(node);
            }
          }
          // Check for tooltip elements within the added node
          if (node.querySelectorAll) {
            initializeTooltips(node);
          }
        }
      });
    });
  });

  // Start observing
  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
